// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"59d87675","915":"b328eb24"}[chunkId] + ".chunk.js";
};